import * as z from "zod"
 
export const formSchema = z.object({
  name: z.string().min(1, "Enter a name"),
  url: z.string().url().optional(),
  description: z.string().optional(),
  category: z.string().optional(),
})
